import { parseNumber } from "common/utils/numbers";
import { useMatch } from "common/router/hooks";
import { stringToValidValue } from "common/utils/strings";

import Error404Page from "client/common/components/errors/Error404Page";
import { Paths } from "client/routes";

import { OnboardingSubscriptionsStep } from "../types";
import OnboardingSubscriptionsContent from "./OnboardingSubscriptionsContent";

const OnboardingDetailSubscriptionPage = () => {
  const match = useMatch<Paths["onboarding"]["subscriptions"]["detail"]>();
  const id = parseNumber(match.params.id);
  const step = stringToValidValue(
    match.params.step,
    Object.values(OnboardingSubscriptionsStep),
    undefined,
  );
  if (Number.isNaN(id)) {
    console.warn(`Invalid id ${id}`);
    return <Error404Page />;
  }
  if (!step) {
    console.warn(`Invalid step ${match.params.step}`);
    return <Error404Page />;
  }
  return <OnboardingSubscriptionsContent id={id} step={step} />;
};

export default OnboardingDetailSubscriptionPage;
